import axios, { AxiosResponse } from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import endpoints from "src/core/endpoints";
import { User } from "src/types/user";
import { RefreshResponse } from "src/types/auth";

export const refreshToken = () => {
  const user: User = JSON.parse(Cookies.get("user") || "{}");

  if (!user) {
    logout();
    return;
  }

  axios
    .post(process.env.REACT_APP_BASE_URL + endpoints.refresh, {
      refresh: user.refresh,
    })
    .then((res: AxiosResponse<RefreshResponse>) => {
      user.auth_token = res.data.auth_token;
      user.refresh = res.data.refresh;

      Cookies.set("user", JSON.stringify(user));

      setTimeout(() => {
        window.location.reload();
      }, 500);
    })
    .catch((err) => {
      toast(err.detail);
      return;
    });
};

export const logout = () => {
  Cookies.remove("user");
  Cookies.remove("platform");
  window.location.href = "/login";
  return;
};
